import { render, staticRenderFns } from "./HighResolutionImage.vue?vue&type=template&id=e36c6c24&"
import script from "./HighResolutionImage.vue?vue&type=script&lang=ts&"
export * from "./HighResolutionImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports